import { Button } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import ComboBox from '../../../Components/ComboBox'
import CustomButton from '../../../Components/CustomButton/CustomButton'
import { Input } from '../../../Components/Input'
import { makeGetRequest, makePostRequest, makePutRequest } from '../../../utils/api'
import { currentDate, convertToMuiDate } from 'utils/helpers'
import urls from '../../../utils/urls'

export default function CreateMyPlantForm({ operations, params, setSelected, setOperations }) {
  const [open, setOpen] = useState(true)
  const [plant, setPlant] = useState([])
  const [selectedPlant, setSelectedPlant] = useState(null)
  const [type, setType] = useState({})
  //   const [selectedPlant, setSelectedPlant] = useState({})

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      id: params[0].id,
      Nom: '',
      Nombre: params[0].Nombre,
      CultureType: { label: `${params[0].CultureType}`, id: `${params[0].CultureType}` },
      LastWat: params[0].LastWat ? convertToMuiDate(params[0].LastWat) : '',
      LastFert: params[0].LastFert ? convertToMuiDate(params[0].LastFert) : '',
      LastRempot: params[0].LastRempot ? convertToMuiDate(params[0].LastRempot) : '',
      Emplacement: params[0].Emplacement,
    },
  })

  function currentDate() {
    const date = new Date()
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const handleClickOpen = () => {
    setOpen(true)
    getPlantList()
  }

  const handleClose = () => {
    setOpen(false)
    reset()
    setSelected(false)
  }

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      Nom: data.Nom.id,
      CultureType: data.CultureType.label,
      Nombre: data.Nombre,
      LastWat: data.LastWat,
      LastFert: data.LastFert,
      LastRempot: data.LastRempot,
      Emplacement: data.Emplacement,
    }
    const response = await makePutRequest(`/api/garden/crudPlant/${data.id}/`, payload, {}, true)
    if (response.status === 200) {
      response.data.Nom = response.data.nom
      let id = response.data.id
      const filteredOperations = operations.results.filter((v) => v.id !== id)
      const updatedOperations = [...filteredOperations, { ...response.data }].sort((a, b) =>
        a.id > b.id ? 1 : -1,
      )

      setOperations((operations) => ({
        ...operations,
        results: updatedOperations,
      }))
      //   setOperations(operations => ({
      //     ...operations,
      //     results: [...operations.results, response.data],
      //     count: operations.count + 1,
      //   }));
      handleClose()
    }
  }

  const getPlantList = async () => {
    const url = urls.getPlantList
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const transformedData = data.results.map((plant) => {
        return { id: plant.id, label: plant.Nom }
      })
      setPlant(transformedData)
    }
  }

  useEffect(() => {
    getPlantList()
    // setValue('CultureType',{label:`${params[0].CultureType}`,id:`${params[0].CultureType}`})
    log()
  }, [])
  const log = () => {
    setType({ label: `${params[0].CultureType}`, id: `${params[0].CultureType}` })
    setSelectedPlant({ id: params[0].Nom?.id, label: params[0].Nom?.Nom })
    setValue('Nom', { id: params[0].Nom?.id, label: params[0].Nom?.Nom })
  }
  //   const handlePlantChange = (event) => {
  //     setSelectedPlant(event.target.value);
  //   }

  return (
    <>
      {/* <CustomButton onClick={handleClickOpen}>Ajouter</CustomButton> */}
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle color="black">Ajout plante</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('Nom', j)
                setSelectedPlant(j)
              }}
              label="Plantes"
              data={plant}
              name="Nom"
              required={true}
              selectedValue={selectedPlant}
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('CultureType', j)
                setType(j)
              }}
              label="Type de culture"
              data={[
                { label: 'Pot', id: 'Pot' },
                { label: 'Sol', id: 'Sol' },
              ]}
              name="CultureType"
              required={true}
              selectedValue={type}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'number',
                step: '1',
              }}
              name="Nombre"
              label="Nombre de plantes"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                id: 'Dernier arrosage',
                type: 'date',
                required: false,
                size: 'small',
                defaultValue: new Date().toISOString().substr(0, 10),
              }}
              name="LastWat"
              label="Dernier arrosage"
            />

            <button onClick={() => setValue('LastWat', currentDate())}>Today</button>

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: false,
                size: 'small',
                defaultValue: new Date().toISOString().substr(0, 10),
              }}
              name="LastFert"
              label="Dernier apport d'/engrais"
            />

            <button onClick={() => setValue('LastFert', currentDate())}>Today</button>

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: false,
                size: 'small',
                defaultValue: new Date().toISOString().substr(0, 10),
              }}
              name="LastRempot"
              label="Dernier rempotage"
            />

            <button onClick={() => setValue('LastRempot', currentDate())}>Today</button>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
              }}
              name="Emplacement"
              label="Emplacement"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
